/**
 * NamespaceBasicInfo
 *
 * First step collecting namespace name and optional description with guidance
 * on what namespaces are.
 */
import React from 'react';
import { Label } from '../../ui/inputs/label';
import { Input } from '../../ui/inputs/input';
import { Textarea } from '../../ui/inputs/textarea';

export default function NamespaceBasicInfo({ formData, setFormData }) {
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-1">
          Namespace Details
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
          Provide basic information about your namespace.
        </p>
        
        <div className="p-4 bg-purple-50 dark:bg-purple-900/20 rounded-lg border border-purple-100 dark:border-purple-800/30 mb-4">
          <h4 className="font-medium text-purple-600 dark:text-purple-300 text-sm mb-2">What is a Namespace?</h4>
          <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
            A namespace in Advocacy Lab is an organizational unit that helps you keep your work structured and well-organized.
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            With namespaces, you can:
          </p>
          <ul className="mt-1 space-y-1 text-sm text-gray-600 dark:text-gray-400">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Organize templates and campaigns by client, team, project, or purpose</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Switch between different workspaces to stay focused on specific goals</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Share resources within your organization while maintaining clear boundaries</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Keep track of teams, permissions, and access controls for collaborative work</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <Label htmlFor="name" className="block mb-1">
            Namespace Name <span className="text-red-500">*</span>
          </Label>
          <Input
            id="name"
            value={formData.name || ''}
            onChange={handleInputChange}
            placeholder="Enter namespace name"
            className="w-full"
            required
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            This will be the name of your organization or team workspace.
          </p>
        </div>

        <div>
          <Label htmlFor="description" className="block mb-1">
            Description
          </Label>
          <Textarea
            id="description"
            value={formData.description || ''}
            onChange={handleInputChange}
            placeholder="Enter a description for this namespace"
            className="w-full h-24"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Provide a brief description of this namespace's purpose (e.g., "Marketing team workspace" or "Client project for Acme Corp").
          </p>
        </div>
      </div>
    </div>
  );
} 